export default __webpack_public_path__ + "static/iconFlor2-51b41c6f7bb9fb80107433602a115655.png";